import { ClerkProvider } from '@clerk/react'
import { useNavigate } from 'react-router-dom'

/**
 * Clerk path-based components need the app router for in-app navigations.
 * ClerkProvider must sit inside BrowserRouter so useNavigate() is valid.
 */
export default function TerraClerkProvider({ children }) {
  const navigate = useNavigate()
  const publishableKey =
    process.env.REACT_APP_CLERK_PUBLISHABLE_KEY ||
    ''

  return (
    <ClerkProvider
      {...(publishableKey ? { publishableKey } : {})}
      afterSignOutUrl="/login"
      routerPush={(to) => {
        navigate(typeof to === 'string' ? to : String(to))
      }}
      routerReplace={(to) => {
        navigate(typeof to === 'string' ? to : String(to), { replace: true })
      }}
    >
      {children}
    </ClerkProvider>
  )
}
